import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("next") || searchParams.get("redirect") || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate(redirect);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: "#050505" }}>
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <p className="font-mono uppercase tracking-[0.3em] text-xs font-bold text-[#39FF14] mb-3">Account</p>
          <h1
            className="text-3xl sm:text-4xl font-black uppercase tracking-tighter text-[#F2F2F2]"
            style={{ fontFamily: "Chivo, sans-serif" }}
          >
            Sign In
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="font-mono uppercase tracking-[0.2em] text-xs font-bold text-[#A1A1A1]">Email</Label>
            <Input
              id="email"
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-[#0D0D0D] border-[#1A1A1A] text-[#F2F2F2] rounded-none focus:border-[#39FF14] focus:ring-1 focus:ring-[#39FF14] placeholder:text-[#A1A1A1]/50"
              placeholder="your@email.com"
            />
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Label htmlFor="password" className="font-mono uppercase tracking-[0.2em] text-xs font-bold text-[#A1A1A1]">Password</Label>
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-[#39FF14] hover:underline font-mono text-[10px] uppercase tracking-wider">
                Forgot password?
              </Link>
            </div>
            <Input
              id="password"
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="bg-[#0D0D0D] border-[#1A1A1A] text-[#F2F2F2] rounded-none focus:border-[#39FF14] focus:ring-1 focus:ring-[#39FF14] placeholder:text-[#A1A1A1]/50"
              placeholder="Enter password"
            />
          </div>

          {error && (
            <div className="p-3 border border-red-500/30 bg-red-500/10 text-red-400 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <Button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-[#39FF14] text-[#050505] hover:bg-[#4DFF2E] rounded-none font-mono uppercase tracking-[0.15em] text-xs font-bold py-6 disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>

        <p className="mt-6 text-[#A1A1A1] text-sm">
          Don&apos;t have an account?{" "}
          <Link to="/register" data-testid="go-to-register" className="text-[#39FF14] hover:underline font-mono text-xs uppercase tracking-wider">
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}
